var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.6382,
    cy: 16.6382,
    r: 14.1382,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5451 15.9225C19.0937 15.7431 17.9247 15.1181 17.9247 14.3947V8.17926C17.9247 7.98829 17.7685 7.83203 17.5775 7.83203C17.3865 7.83203 17.2302 7.98829 17.2302 8.17926V14.3947C17.2302 15.1123 16.0612 15.7374 15.6098 15.9225C15.4304 15.992 15.3436 16.1945 15.4131 16.3739C15.4651 16.5128 15.5982 16.5939 15.7371 16.5939C15.7777 16.5939 15.824 16.5881 15.8645 16.5707C16.0149 16.5071 17.0277 16.0846 17.5717 15.3612C18.1157 16.0904 19.1284 16.5128 19.2789 16.5707C19.4583 16.6402 19.6609 16.5534 19.7303 16.3739C19.8113 16.1945 19.7245 15.992 19.5451 15.9225Z",
    fill: "#0AD2C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2662 23.1911C13.1446 23.1911 13.0231 23.1853 12.9016 23.168C12.647 23.1332 12.4155 23.0869 12.1608 23.0349C11.4258 22.8786 10.6677 22.7166 9.33667 22.9712C9.01837 23.0291 8.6885 22.9481 8.43386 22.7455C8.17923 22.5429 8.02876 22.2362 8.01719 21.9121C7.97089 20.2454 7.97667 17.103 8.58433 14.7823C8.93156 13.4628 9.68969 12.3343 10.8471 11.4315C11.6805 10.7833 12.6932 10.2625 13.8681 9.88633C14.3889 9.7185 14.9445 9.80531 15.3901 10.1294C15.8299 10.4535 16.0845 10.9512 16.0845 11.4952V20.3496C16.0845 20.4306 16.0788 20.5116 16.073 20.5927C16.0093 21.3624 15.6216 22.0858 15.0197 22.5719C14.5162 22.977 13.9028 23.1911 13.2662 23.1911ZM10.633 22.1436C11.3159 22.1436 11.8367 22.2536 12.3113 22.352C12.5486 22.4041 12.7685 22.4504 12.9942 22.4793C13.5671 22.5545 14.1343 22.3925 14.5915 22.0221C15.0486 21.6517 15.338 21.1077 15.3901 20.5232C15.3959 20.4596 15.3959 20.4017 15.3959 20.338V11.4894C15.3959 11.1653 15.2454 10.8759 14.985 10.685C14.7246 10.494 14.3947 10.4419 14.088 10.5403C12.2592 11.1248 9.93854 12.3633 9.26722 14.9501C8.68271 17.1898 8.67693 20.257 8.72322 21.889C8.72901 22.0105 8.7811 22.1263 8.87948 22.2015C8.97786 22.2767 9.09361 22.3115 9.21514 22.2883C9.75913 22.1841 10.2221 22.1436 10.633 22.1436Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8891 22.9879C21.2525 22.9879 20.6391 22.7738 20.1298 22.3629C19.5279 21.8768 19.1402 21.1534 19.0765 20.3837C19.0707 20.3027 19.0649 20.2216 19.0649 20.1406V11.2862C19.0649 10.7422 19.3196 10.2445 19.7594 9.92041C20.205 9.59632 20.7548 9.50951 21.2814 9.67734C22.4562 10.0535 23.469 10.5744 24.3024 11.2225C25.4598 12.1253 26.2179 13.2538 26.5652 14.5733C27.1728 16.894 27.1786 20.0364 27.1323 21.7032C27.1207 22.0272 26.9703 22.334 26.7156 22.5365C26.461 22.7391 26.1369 22.8259 25.8128 22.7622C24.4818 22.5134 23.7236 22.6754 22.9887 22.8259C22.7398 22.878 22.5025 22.93 22.2479 22.959C22.1264 22.9821 22.0106 22.9879 21.8891 22.9879ZM19.771 20.3258C19.8231 20.9103 20.1124 21.4543 20.5696 21.8247C21.021 22.1893 21.5882 22.3513 22.1669 22.2819C22.3926 22.2529 22.6125 22.2066 22.8498 22.1546C23.6137 21.9925 24.476 21.8073 25.9459 22.0851C26.0675 22.1083 26.189 22.0793 26.2816 21.9983C26.3742 21.9231 26.4321 21.8073 26.4378 21.6858C26.4841 20.0596 26.4783 16.9924 25.8938 14.7469C25.2167 12.1658 22.8961 10.9216 21.0731 10.3429C20.7664 10.2445 20.4365 10.2966 20.1761 10.4876C19.9157 10.6785 19.7652 10.9679 19.7652 11.292V20.1464C19.7652 20.2043 19.7652 20.2621 19.771 20.3258Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 37.2765,
    height: 37.2765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingIcon);
export default __webpack_public_path__ + "static/media/breathing-icon.9f060acfd50e6f8acbf87ab5c7950fec.svg";
export { ForwardRef as ReactComponent };